import { render, staticRenderFns } from "./ProfessionalsSearchBox.vue?vue&type=template&id=e5b78340&"
import script from "./ProfessionalsSearchBox.vue?vue&type=script&lang=js&"
export * from "./ProfessionalsSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports